module.exports = __webpack_public_path__ + "static/media/passport_hero_desktop@2x.77f6479b.png";